import SecuritiesView from './SecuritiesView';

export default SecuritiesView;



// WEBPACK FOOTER //
// ./src/views/payoutsAndTaxes/securities/index.js